// Copyright (c) 2022 by Move Closer

import { ThemeRegistry } from '../../composables'

import { ProgressBarTheme } from './ProgressBar.contracts'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export const progressBarThemeClassRegistry: ThemeRegistry<string> = {
  [ProgressBarTheme.Default]: '',
  [ProgressBarTheme.Primary]: '--primary'
}
